<template>
    <div class="container mescroll-touch">
        <!-- <img src="../../assets/images/timelinetopnew.png" class="img" /> -->
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;{{
            Name }}
        </div>
        <div class="wait" v-if="nonemess">敬请期待！</div>
        <div class="searchrow">
            <input class="searchinput" type="text" v-model="searchname" placeholder="请输入会议主题或姓名查询">
            <img class="searchicon" src="../../assets/images/timesearch.png" alt="" @click="searching(sedate, actdate)">
        </div>
        <div class="arearow">
            <el-select v-model="choosearea" placeholder="请选择会场" @change="searching(sedate, actdate)">
                <el-option label="所有会场" value="">
                </el-option>
                <el-option v-for="item in arealist" :key="item.Address" :label="item.Address" :value="item.Address">
                </el-option>
            </el-select>
        </div>
        <div class="daterow">
            <div class="dateitem" v-for="(item, index) in searchdate" :key="index"
                @click="listdate(item.DateStr, index)" :class="{ 'active': activedate === index }">{{ item.DateZH }}
            </div>
        </div>
        <div class="meetingtip" v-for="(item, index) in datemeetinglist" :key="index"
            @click="toinfo(item.Id, item.Theme)">
            <div class="meetingplace">
                <img class="meetingpicon" src="../../assets/images/meetingplace.png" alt="">
                <div class="bw">{{ item.Address }}</div>
            </div>
            <div class="meetingmain">
                <div class="mrow">
                    <img class="meetingpicon" src="../../assets/images/meetingtime.png" alt="">
                    <div class="bp">{{ item.DateTimeStr }}</div>
                </div>
                <div class="mrow1">
                    <img class="meetingpicon" src="../../assets/images/meetingtitle.png" alt="">
                    <div class="bp">{{ item.Theme }}</div>
                </div>
                <!-- <div class="mrow2">
                    <img class="meetingpicon" src="../../assets/images/meetingchairman.png" alt="">
                    <div class="bp">主席：{{ item.Chairman }}</div>
                </div> -->
            </div>
        </div>
        <!-- <floatback /> -->
        <div class="backbtn" @click="back()">
            <img src="../../assets/images/backicon.png" alt="">
        </div>
    </div>
</template>

<script>
// import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'customtimeline',
    data() {
        return {
            searchval: "",
            searchdate: '',
            actdate: '',
            sedate: '',
            activedate: 0,
            datemeetinglist: [],
            nonemess: 0,
            searchname: '',
            Name: this.$route.query.Name,
            arealist: [],
            choosearea: '',
        }
    },
    mixins: [mixin],
    components: {
        // floatback
    },
    created() {
        this.getinfo();
        this.getmod();
        document.title = this.Name;
        this.getdate();
    },
    mounted() {
        this.initDrag();
    },
    methods: {
        getmod() {
            let that = this
            this.$axios
                .get("/api/api/web/Activity/GetModel?id=" + this.$route.query.ActivityId)
                .then((res) => {
                    that.meetinginfo = res.Data
                    this.initzqShare(that.meetinginfo.ForwardMainTitle, this.$route.query.Name, that.meetinginfo.ForwardPic);
                });
        },
        getinfo() {
            let that = this;
            this.$axios.get('/api/api/web/Activity/GetModuleModel?id=' + this.$route.query.Id).then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    that.imgurl = res.Data.Cover
                }
            });
        },
        getarea() {
            let that = this;
            this.$axios.post('/api/api/web/Activity/GetScheduleAddressList', {
                ActivityCode: this.$route.query.code,
                Date: that.sedate
            }).then(res => {
                if (res.RetCode == "10000") {
                    // console.log(res.Data.Url)
                    // that.imgurl = res.Data.Cover
                    that.arealist = res.Data
                }
            });
        },
        getdate() {
            let that = this;
            this.$axios.post(' /api/api/web/activity/GetScheduleDateNew', {
                ActivityCode: this.$route.query.code,
            }).then(res => {
                that.searchdate = res.Data
                if (res.Data.length > 0) {
                    that.sedate = res.Data[0].DateStr
                    that.actdate = 0
                    that.getarea();
                    that.$axios.post(' /api/api/web/activity/GetScheduleNew', {
                        ActivityCode: this.$route.query.code,
                        Date: res.Data[0].DateStr,
                        Name: that.searchname,
                        Address: that.choosearea
                    }).then(res => {
                        that.datemeetinglist = res.Data
                        // console.log(res.Data)
                    })
                } else {
                    that.nonemess = 1
                }
                // console.log(res.Data)
            })
        },
        listdate(e, i) {
            let that = this;
            // console.log(e)
            this.activedate = i
            that.sedate = e
            that.actdate = i
            that.getarea();
            // console.log(i)
            this.$axios.post(' /api/api/web/activity/GetScheduleNew', {
                ActivityCode: this.$route.query.code,
                Date: e,
                Name: that.searchname,
                Address: that.choosearea
            }).then(res => {
                that.datemeetinglist = res.Data
                // console.log(res.Data)
            })
        },
        searching(e, i) {
            let that = this
            that.listdate(e, i)
        },
        toinfo(i, t) {
            this.$router.push({
                path: 'custommeetinginfo',
                query: {
                    Id: i,
                    title: t,
                    ActivityId: this.$route.query.ActivityId
                }
            });
        },
        back() {
            this.$router.replace({
                path: "custom",
                query: {
                    Id: this.$route.query.ActivityId,
                },
            });
        },
        initDrag() {
            const btn = document.querySelector('.backbtn');
            if (!btn) return;

            // 触摸开始（移动端）
            btn.addEventListener('touchstart', (e) => {
                this.isDragging = true;
                // 获取初始触摸位置
                this.startX = e.touches[0].clientX;
                this.startY = e.touches[0].clientY;
                // 获取按钮当前位置
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                // 阻止默认行为
                // e.preventDefault();
            });

            // 触摸移动（移动端）
            btn.addEventListener('touchmove', (e) => {
                if (!this.isDragging) return;
                // 计算移动距离
                const moveX = e.touches[0].clientX - this.startX;
                const moveY = e.touches[0].clientY - this.startY;
                // 设置按钮新位置
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                // 清除原有right/transform
                btn.style.right = 'auto';
                btn.style.transform = 'none';
                e.preventDefault();
            });

            // 触摸结束（移动端）
            btn.addEventListener('touchend', () => {
                this.isDragging = false;
            });

            // 兼容PC端鼠标操作
            btn.addEventListener('mousedown', (e) => {
                this.isDragging = true;
                this.startX = e.clientX;
                this.startY = e.clientY;
                const rect = btn.getBoundingClientRect();
                this.btnX = rect.left;
                this.btnY = rect.top;
                e.preventDefault();
            });

            document.addEventListener('mousemove', (e) => {
                if (!this.isDragging) return;
                const moveX = e.clientX - this.startX;
                const moveY = e.clientY - this.startY;
                btn.style.left = `${this.btnX + moveX}px`;
                btn.style.top = `${this.btnY + moveY}px`;
                btn.style.right = 'auto';
                btn.style.transform = 'none';
            });

            document.addEventListener('mouseup', () => {
                this.isDragging = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    min-height: 100%;
    padding-bottom: 1.5rem;
    width: 100%;
    // background: rgb(228, 236, 255);
    background: rgb(227, 235, 253);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(179, 178, 255);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: #b3b2ff;
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: 1rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(177, 172, 255);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 50%;
    // text-align: center;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.name1 {
    width: 50%;
    text-align: right;
    font-size: .37rem;
    // margin: 0.1rem 0;
}

.perplebold {
    color: #8483d1;
    font-weight: bold;
}

.wait {
    text-align: center;
    color: rgb(111, 86, 250);
    font-weight: bold;
    font-size: .55rem;
    margin-top: 20%;
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.searchrow {
    width: 90%;
    background: #fff;
    margin: auto;
    margin-top: 0.5rem;
    border-radius: 0.133333rem;
    box-shadow: -0.026667rem 0.053333rem 0.16rem 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.3rem;
    box-sizing: border-box;
}

.searchinput {
    width: 85%;
    border: 0;
}

.searchicon {
    display: block;
    width: 8%;
    padding-left: 4%;
    border-left: 1px solid #c3c3c3;
}

.daterow {
    display: flex;
    width: 90%;
    margin: auto;
    overflow-x: auto;
    color: #003585;
    margin-top: 0.5rem;
    padding-bottom: 0.2rem;
    margin-bottom: 0.3rem;
}

.dateitem {
    background: linear-gradient(to right, #fff, #eaf0fb);
    font-size: .5rem;
    padding: 0.3rem 0.3rem;
    margin-right: 0.5rem;
    flex: 0 0 auto;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}

.active {
    background: linear-gradient(to right, rgb(0, 53, 133), rgb(0, 61, 193));
    color: #fff
}

.meetingtip {
    width: 90%;
    margin: auto;
    margin-bottom: 0.5rem;
}

.meetingplace {
    background: linear-gradient(to right, rgb(0, 53, 133), rgb(0, 61, 193));
    color: #fff;
    display: flex;
    flex-direction: row;
    padding: 0.3rem;
    align-items: center;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin-bottom: 0.3rem;
}

.bw {
    color: #fff;
    font-size: .45rem;
    margin-left: 0.2rem;
    font-weight: bold;
}

.meetingpicon {
    width: 6%;
}

.meetingmain {
    background: linear-gradient(to right, #fff, #eaf0fb);
    color: #6E56FB;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 0.3rem;
}

.mrow {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.3rem;
}

.mrow1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
    margin-bottom: 0.3rem;
}

.mrow2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0;
}

.bp {
    color: #003585;
    font-size: .45rem;
    font-weight: bold;
    margin-left: 0.2rem;
}

.wait {
    text-align: center;
    color: rgb(0, 53, 133);
    font-weight: bold;
    font-size: .55rem;
    padding-top: 20%;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background: #003583;
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.arearow {
    width: 90%;
    text-align: center;
    margin: auto;
    margin-top: .5rem;
}

::v-deep .el-select {
    width: 100%;
}

.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
    z-index: 99999;
    /* 新增拖动相关样式 */
    touch-action: none;
    /* 禁用浏览器默认触摸行为 */
    user-select: none;
    /* 防止拖动时选中文字 */
    -webkit-user-drag: element;
    /* 开启移动端拖动 */
    cursor: move;
    /* 鼠标指针提示可拖动 */
    transition: transform 0.1s ease;
    /* 拖动过渡更顺滑 */
}

.backbtn:active {
    opacity: 1;
    /* 拖动时提高透明度，增强反馈 */
    transform: translateY(-50%) scale(1.05);
    /* 拖动时轻微放大，提升体验 */
}

.backbtn img {
    width: 100%;
    pointer-events: none;
    /* 让拖动事件穿透到父元素 */
}
</style>